<template>
  <div class="invoice-container">
    <nav class="add-navigation">
      <div class="row">

        <div class=" col-12">

          <search-input

              v-model="Searched"
              placeholder="Search for company"
          />

        </div>

      </div>
      <div class="primary-button">
        <primary-button @click.native="createManualPayment">Create Manual Payment</primary-button>
      </div>
    </nav>
    <loader :loading="loading" v-if="loading" />
    <not-found v-else-if="isFound" />
    <template v-else>
      <div class="table_div" style="width:100%;overflow-x:auto;overflow-y:hidden">
        <table class="Invoice_table">
          <thead>
            <tr class="Invoice_table_header">
              <th class="date-time">
                Created On
                <span @click="sorting('up','created_on')" class="sorting">&#8593;</span>
                <span @click="sorting('down','created_on')" class="sorting">&#8595;</span>
              </th>
              <th>Created By</th>
              <th>Method</th>
              <th>Total</th>
              <th>Note</th>
              <th>
                Company
                <span @click="sorting('up','company_name')" class="sorting">&#8593;</span>
                <span @click="sorting('down','company_name')" class="sorting">&#8595;</span>
              </th>
              <th>
                Transaction ID
                <span @click="sorting('up','payment_uuid')" class="sorting">&#8593;</span>
                <span @click="sorting('down','payment_uuid')" class="sorting">&#8595;</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class v-for="(payment, k) in payments" :key="k">
              <th class="date-time">{{payment.createdOn}}</th>
              <th class="creadted_by">
                {{payment.createdBy}}
              </th>
              <th class="method">{{payment.method}}</th>
              <th class="Invoice_price">${{payment.amount}}</th>
              <th class="Invoice_price"></th>
              <th>{{ payment.companyName }}</th>
              <th @copy="copyFullName" :title="payment.tranId">{{ payment.tranId | shortId }}</th>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col col-lg-7 col-md-6 col-xs-12 per-page">
        <span class="filter_by">Show Per Page:</span>
        <div class="primary-input-container choose-type perPage">
          <primary-select
            type="text"
            @input="changePerPage"
            v-model="per_page" :is-cross="false"
            class="choose-type perPage"
            placeholder="Select"
          >
            <option :value="item" v-for="(item,key) in pages" :key="key">{{item}}</option>
          </primary-select>
        </div>
      </div>
      <div class="buttons-wrapper">
        <pagination-component
          @change-page="changePage($event)"
          :page="Page"
          :total="TotalPages"
          :perPage="per_page"
          :qnt="payments.length"
        />
      </div>
    </template>
    <Modal v-if="showPaymentModal" @close="showPaymentModal = null" >
      <h3 slot="header"></h3>
      <div slot="body">
        <form class="form">
          <div class="row d-block">
            <div id="modal-fields" class="">
              <div class="col-md-12 field-width">
                <div class="form-group">
                  <primary-select
                    type="text"
                    name="client"
                    v-model="manualPayment.client"
                    v-validate="'required'"
                    :class="{'input': true, 'is-danger': errors.has('client')}"
                    :options="clientList"
                  />
                  <div
                    class="help is-danger"
                    v-if="errors.has('client')"
                  >{{ errors.first('client') }}</div>
                </div>
              </div>
              <div class="col-md-12 field-width">
                <div class="form-group">
                  <primary-input
                    type="text"
                    name="amount"
                    class="field"
                    v-model="manualPayment.amount"
                    v-validate="'required'"
                    :class="{'input': true, 'is-danger': errors.has('amount')}"
                    placeholder="Amount"
                  />
                  <div
                    class="help is-danger"
                    v-if="errors.has('amount')"
                  >{{ errors.first('amount') }}</div>
                </div>
              </div>
              <div class="col-md-12 field-width">
                <div class="form-group">
                  <text-area
                    placeholder="Note"
                    v-model="manualPayment.note"
                    maxlength="160"
                    :cols="'10'"
                    :rows="'6'"
                    class="text-area-description"
                    name="Note"
                  />
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div slot="footer" class="d-flex m-0">
        <button class="btn btn-primary submit customBtnStyle" @click="addPayment">Submit</button>
        <!--            <primary-button class="customBtnStyle">Submit</primary-button>-->
        <!--            <secondary-button @click="showPaymentModal = null">Cancel</secondary-button>-->
        <button @click="showPaymentModal = null" class="btn btn-default cancel">Cancel</button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { format } from "date-fns";

export default {
  components: {
    DownloadAttachmentDropDown: () =>
      import("@/components/DropDowns/Billing/DownloadAttachmentDropDown.vue"),
    SearchInput: () => import("@/components/Inputs/SearchInput.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    PaginationComponent: () => import("@/components/Pagination.vue"),
    Modal: () => import("@/components/Modal.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    PrimaryInput: () => import("@/components/Inputs/PrimaryInput.vue"),
    TextArea: () => import("@/components/Inputs/TextArea"),
    Loader: () => import("@/components/Loader.vue"),
    NotFound: () => import("@/components/NotFound.vue"),
  },
  data: () => ({
    showDropDown: false,
    showPaymentModal: null,
    manualPayment: {
      client: "",
      amount: null,
      note: "",
    },
    clientList: [],
    payments: [],
    PerPage: null,
    Total: null,
    Searched: "",
    Page: 0,
    TotalPages: null,
    pages: [10, 20, 50, 100, 200],
    per_page: 10,
    loading: true,
    isFound: false,
    timeout: null
  }),
  watch: {
    Searched(searchedText) {
      clearTimeout(this.timeout);

      this.timeout = setTimeout(() => {
        this.Page = 0;
        this.GetList();
      }, 800);
    },
  },
  filters: {
    shortId(id) {
      if (!id) {
        return "";
      }
      return `${id.slice(0, 9)}...`;
    },
  },
  created() {
    this.GetList();
    this.getCompanyList();
  },
  methods: {
    sorting(type, sortBy) {
      let order_dir = "";
      if (type === "up") {
        order_dir = "desc";
      } else {
        order_dir = "asc";
      }

      this.GetList(order_dir, sortBy);
    },
    copyFullName(e) {
      const fullName = e.target.getAttribute("title");
      const input = document.createElement("input");
      input.value = fullName;
      input.style.opacity = "0";
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
    },
    async addPayment() {
      const valid = await this.$validator.validate()

      if (valid) {
        let payment = {
          method: "manual",
          company_uuid: this.manualPayment.client,
          amount: this.manualPayment.amount,
        }
        this.$store
          .dispatch("AddPayment", payment)
          .then((res) => {
            this.manualPayment.client = ''
            this.manualPayment.amount = ''
            this.manualPayment.note = ''
            this.showPaymentModal = null;
            this.$snotify.success("Payment successfully created.", {
              timeout: 3000,
            });
            this.GetList();
          });
      }
    },
    getCompanyList() {
      this.$store
        .dispatch("GetCompanyList", {
          perPage: 1000,
        })
        .then((res) => {
          console.log('s', res)
          this.clientList = [
            { name: 'Select Client', value: '' },
            ...res.items.map(this.transformCompany)
          ];
        });
    },
    changePerPage(e) {
      this.Page = 0;
      this.GetList();
    },
    changePage(page) {
      this.Page = page;
      this.GetList();
    },
    createManualPayment() {
      this.showPaymentModal = !this.showPaymentModal;
    },
    GetList(order_dir, sortBy) {
      this.loading = true
      this.isFound = false;
      this.$store
        .dispatch("GetPaymentList", {
          company_name: this.Searched,
          page: this.Page,
          per_page: this.per_page ? this.per_page : 10,
          order_by: sortBy,
          order_dir: order_dir,
        })
        .then((res) => {
          this.loading = false;
          if (!res.items.length) {
            this.isFound = true;
            return 
          }
          this.payments = res.items.map(this.transformPayments);
          this.TotalPages = res.total / res.per_page;
        });
    },
    transformPayments(i, k) {
      return {
        tranId: i.tran_id,
        invoiceNumber: i.invoice_number,
        method: i.method,
        createdOn: format(i.created_on, "YYYY:MM:DD HH:mm:ss"),
        createdBy: i.created_by,
        companyName: i.company_name,
        amount: i.amount,
      };
    },
    transformCompany(item) {
      return {
        name: item.contact && item.contact.full_name,
        value: item.company_uuid
      }
    },
    outside() {
      this.showDropDown = false;
    },
  },
};
</script>

<style lang="scss" scoped>
#modal-fields .help {
  margin-top: 0;
}
</style>

<style lang="scss" scoped>
.sorting {
  font-size: 16px;
  cursor: pointer;
}
.per-page {
  display: flex;
  align-items: center;
  margin-top: 20px;
  padding: 0;
}
.perPage {
  width: 120px;
  display: inline-block;
}
.filter_by {
  margin-right: 15px;
}
.buttons-wrapper {
  width: 100%;
  justify-content: flex-end !important;
}
.user-container .add-navigation .right-wrapprr .search-input {
  width: 100% !important;
}

@media (max-width: 891px) {
  .right-wrapprr {
    width: 100% !important;
  }
}
@media (max-width: 767px) {
  .add-navigation {
    display: block !important;
    height: auto !important;
  }
  .buttons-wrapper {
    justify-content: flex-start !important;
    margin-top: 15px;
  }
  .add-navigation .primary-button {
    width: 220px !important;
    margin-top: 10px !important;
  }
}
@media (max-width: 600px) {
  .right-wrapprr {
    display: block !important;
  }
  .buttons-wrapper {
    width: 100% !important;
  }
  .col-lg-6.col-md-7.col-xs-12 {
    margin-top: 15px;
  }
}
.add-navigation {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  margin-top: 20px;
  margin-bottom: 20px;
  .search-input {
    height: 40px;
    width: 345px;
    background-color: #ffffff;
  }
  .primary-button {
    /*height: 40px;*/
    /*width: 131px;*/
  }
}
.m-top-100 {
  display: flex;
  margin: 0 auto;
}
.customBtnStyle {
  margin-right: 20px;
}
.btn.btn-default.cancel {
  cursor: pointer;
  height: 100%;
  width: 100%;
  border: 1px solid #bdbfd8;
  border-radius: 4px;
  background-color: #ffffff;
  color: #55616e;
  font-family: "Helvetica Neue";
  font-size: 16px;
  font-weight: 500;
  line-height: 18px;
  text-align: center;
  padding: 10px 20px 10px 20px;
}
.btn.btn-primary.submit {
  cursor: pointer;
  height: 40px;
  width: 100%;
  border-radius: 4px;
  background-color: #51a3f3;
  color: white;
  outline: none;
  border: none;
  font-family: "Helvetica Neue";
  font-size: 16px;
  font-weight: 500;
  line-height: 30px;
  text-align: center;
  padding: 5px 20px 5px 20px;
}
.buttons-wrapper {
  display: flex;
  align-items: center;
  width: 100%;
  .secondary-button {
    height: 40px;
    width: 90px;
    margin-right: 15px;
  }
}

.popup_content {
  display: none;
}
.popup_cta {
  cursor: pointer;
}

table.Invoice_table {
  width: 100%;
  margin-top: 21px;

  .date-time {
    width: 200px;
    padding-left: 0;
    padding-right: 0;
  }
}
table thead tr {
  background: linear-gradient(135deg, #51a3f3 0%, #51b5f3 100%);
}
.Invoice_table thead th:first-child {
  padding-left: 20px;
  padding-right: 30px;
  width: 14%;
}
.Invoice_table tr {
  width: 100%;
  height: 44px;
  box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -webkit-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -moz-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  background-color: #ffffff;
}
.Invoice_table tbody tr th {
  color: #212b36;
  font-weight: normal;
  font-family: "Helvetica Neue";
  height: 20px;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  padding: 7px 0px 7px 0px;
  text-align: center;
}
table tr th {
  padding: 7px 10px 7px 0;
}
table {
  border-collapse: collapse;
}
.Invoice_table_header th {
  color: white;
  padding-left: 10px;
  border-bottom-width: 2px;
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
  border: 1px solid #dee2e6;
  padding: 0.75rem;
  text-align: center;
}
.Invoice_table_popup {
  height: 30px;
  text-align: right;
  position: relative;
  padding: 0;
  float: right;
  .popup_cta {
    cursor: pointer;
    color: #55616e;
  }
}

.Invoice_table table thead th:first-child {
  padding-left: 35px;
}
.Invoice_table tbody th:first-child {
  padding-left: 0px;
}
tbody th.created_by {
  line-height: 20px;
  height: 20px;
  padding: 7px 0 27px 0;
}
.svg-grey {
  fill: #55616e;
  margin-left: 3px;
}
.popup_image {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 8px;
}
th.user_active:after {
  content: "";
  height: 10px;
  width: 10px;
  background-color: #24e2b8;
  position: absolute;
  border-radius: 50%;
  left: 12px;
  top: 25px;
}

th.user_active {
  text-align: left;
  position: relative;
  padding-left: 32px;
}
@media (max-width: 1425px) {
  table.Invoice_table {
    width: 1300px;
  }
}
.table_div::-webkit-scrollbar {
  // width: 5px;
  width: 8px;
  height: 8px;
  background-color: #f5f5f5;
}

.table_div::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-image: -webkit-gradient(
    linear,
    left bottom,
    left top,
    color-stop(0.44, #51a3f3),
    color-stop(0.72, #51a3f3),
    color-stop(0.86, #51a3f3)
  );
}
</style>

